import React from 'react';
import LegalPage from '@/components/LegalPage';

const CONTENT = `## 1. Aceptación

Estos términos regulan el uso de EVALPRO, la plataforma disponible en ejerciciofisicoysalud.com (en adelante, "EVALPRO", "nosotros"). Al comprar, crear una cuenta o usar la plataforma, aceptás estos términos y la **Política de Privacidad**. Si no estás de acuerdo con algo, no uses EVALPRO.

## 2. Qué es EVALPRO

EVALPRO es una herramienta de apoyo para profesionales del ejercicio: profesores de educación física, entrenadores, kinesiólogos y otros profesionales del movimiento. Ordena la entrevista inicial de salud antes de empezar a entrenar y genera un informe con recomendaciones, basado en el algoritmo de screening preparticipativo del American College of Sports Medicine (ACSM) y bibliografía complementaria.

## 3. Qué no es EVALPRO

**EVALPRO no es una herramienta médica: no diagnostica ni prescribe ejercicio.** Sus recomendaciones están pensadas para el profesional del ejercicio, dentro del alcance de su rol, y no reemplazan:

- la consulta médica ni el apto médico;
- la evaluación clínica;
- la prescripción profesional del ejercicio;
- el criterio del profesional que la usa.

Las decisiones que se tomen con cada alumno o paciente las toma el profesional, que es quien conoce a la persona y quien responde por ellas.

## 4. Quién puede usarla

- Personas mayores de 18 años.
- Para uso profesional, con la formación y las habilitaciones que exija tu profesión y tu jurisdicción.

## 5. Tu cuenta

- La cuenta es personal. Sos responsable de cuidar tu contraseña y lo que se haga con tu cuenta.
- **Gimnasios**: la cuenta del gimnasio la usan los entrenadores que el gimnasio habilita. El gimnasio es responsable de quiénes acceden y de lo que cargan.
- Si notás un uso que no reconocés, avisanos enseguida.

## 6. Productos y precios

- **EVALPRO ilimitado**: pago único, sin suscripción. Entrevistas ilimitadas mientras EVALPRO siga funcionando.
- **Pack de entrevistas**: cada pack trae una cantidad fija de entrevistas iniciales. Las reentrevistas y las pruebas funcionales de esa misma persona no gastan. Las entrevistas del pack no vencen. Lo pagado en packs se descuenta del precio del ilimitado, y cuando llega a ese precio la cuenta pasa sola a ilimitada.
- **Gimnasios**: capacitación y cuenta para el equipo. Las condiciones (cantidad de entrenadores, precio y forma de pago) se acuerdan por escrito antes de pagar, y en lo demás rigen estos términos.
- La **capacitación en vivo** que se incluye con la compra se hace por videollamada; si no podés estar, queda grabada.

Los precios están en pesos argentinos y son precios finales. El precio que vale es el que se muestra al momento de pagar. Los pagos con tarjeta, dinero en cuenta o efectivo los procesa **Mercado Pago**, con sus propias condiciones. Podemos cambiar los precios en adelante, pero nunca lo que ya pagaste.

## 7. Garantía y arrepentimiento: 10 días

Tenés **10 días corridos** desde la compra para arrepentirte, **sin dar explicaciones y sin costo**, como establece el artículo 34 de la Ley 24.240 de Defensa del Consumidor. Para pedirlo, escribí a **ejerciciofisicoysaludarg@gmail.com** desde el mail con el que compraste. Te devolvemos el total por el mismo medio de pago, y el acceso comprado se da de baja.

## 8. Lo que te toca como profesional

- Cargar datos verdaderos y completos.
- Tener el **consentimiento informado** de cada alumno o paciente antes de cargar sus datos o mandarle el link. Si es menor de edad, el de su madre, padre o tutor.
- Interpretar el informe con tu criterio profesional y derivar a un médico cuando corresponda.
- Usar EVALPRO dentro del alcance legal de tu profesión.
- No intentar acceder a datos de otras cuentas, ni copiar, revender o desarmar la plataforma.

## 9. Responsabilidad

EVALPRO se ofrece tal como está, y hacemos lo razonable para que funcione bien, sin errores y sin cortes. Aun así:

- **No respondemos por las decisiones profesionales** que se tomen con cada alumno o paciente: esas decisiones son del profesional (punto 3).
- No respondemos por datos cargados equivocados, incompletos o sin autorización.
- Puede haber cortes o fallas por mantenimiento, por problemas de los proveedores (servidores, pagos, mails) o por causas ajenas a nosotros. Cuando pase, lo resolvemos lo antes posible.
- En los casos que la ley lo permite, nuestra responsabilidad total frente a vos no supera lo que pagaste por EVALPRO en los 12 meses anteriores al reclamo.

Nada de esto limita la responsabilidad por dolo o culpa grave, ni los derechos que te da la Ley de Defensa del Consumidor cuando corresponda aplicarla.

## 10. Cambios y continuidad del servicio

EVALPRO se va mejorando: podemos agregar, cambiar o sacar funciones. Si alguna vez dejara de funcionar, **te avisamos por mail con al menos 30 días de anticipación**, para que puedas descargar tus informes.

## 11. Propiedad intelectual

El código, el diseño, los textos, la lógica del motor de decisión, la marca y el logo de EVALPRO son nuestros o de quienes nos dan licencia. No se pueden copiar, modificar, distribuir ni usar comercialmente sin autorización por escrito. Los informes que generás son para que los uses en tu trabajo con tus alumnos o pacientes.

## 12. Datos de tus alumnos

Los datos que cargás de tus alumnos o pacientes no son nuestros: son de ellos, y vos sos quien los administra. Los tratamos solo para prestarte el servicio, como explica la **Política de Privacidad**.

## 13. Suspensión y baja

Podemos suspender o dar de baja una cuenta si se usa para fraude, si se dieron datos falsos o si se incumplen estos términos de forma grave. Salvo que sea urgente, antes te avisamos para que puedas explicar o corregir.

Vos podés pedir la baja de tu cuenta cuando quieras, escribiendo a **ejerciciofisicoysaludarg@gmail.com**. Qué pasa con tus datos después está en la Política de Privacidad.

## 14. Cambios en estos términos

Si los cambiamos, publicamos la versión nueva acá con su fecha. Si el cambio es importante, te avisamos por mail. Si seguís usando EVALPRO después del cambio, se entiende que lo aceptás.

## 15. Ley aplicable y reclamos

Estos términos se rigen por las leyes de la República Argentina. Ante cualquier diferencia, primero escribinos: la idea es resolverla de buena fe. Si no se resuelve, intervienen los tribunales ordinarios de la ciudad de La Plata, provincia de Buenos Aires. Si sos consumidor, podés reclamar también ante los tribunales de tu domicilio y ante los organismos de Defensa del Consumidor.

## 16. Contacto

Consultas, pedidos o reclamos: **ejerciciofisicoysaludarg@gmail.com**
`;

export default function TermsPage() {
  return (
    <LegalPage
      title="Términos y Condiciones de Uso — EVALPRO"
      lastUpdated="Última actualización: 31 de octubre de 2026"
      content={CONTENT}
      testId="terms-page"
    />
  );
}
